<script>
    import MobileFooter from '../../reusableitems/mobileFooter.svelte';
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';

    const team = [
        {
            color: '#FFFFFF',
            imgsrc: 'images/teamMobile/team/adnan.png',
            name: 'Adnan Yunus',
            title: 'Founder',
            desigination: 'CEO',
            role: 'Cheif Data Scientist',
            href: 'https://twitter.com/udnaan',
            linked: '/images/team/twiter.svg',
        },
        {
            color: '#FFFFFF',
            imgsrc: 'images/teamMobile/team/asra.png',
            name: 'Asra Nadeem',
            title: 'Co - Founder',
            desigination: 'COO',
            role: 'Business Development',
            href: 'https://www.linkedin.com/in/asranadeem/',
            linked: '/images/team/linkden.svg',
        },
        {
            color: '#FFFFFF',
            imgsrc: 'images/teamMobile/team/zaeem.png',
            name: 'Zaeem Zoqi',
            title: '',
            desigination: 'Head of Design & Creative',
            role: '',
            href: 'https://www.linkedin.com/in/zaeem-zoqi-19671189/',
            linked: '/images/team/linkden.svg',
        },
    ];
    const design = [
        {
            color: 'rgba(231, 255, 214, 1)',
            imgsrc: 'images/teamMobile/team/abdullah.png',
            name: 'Abdullah Qamar',
            title: '',
            desigination: 'Visual Artist, / 3D Design',
            role: '',
            href: 'https://www.linkedin.com/in/abdullah-qamar-618057206/',
        },
        {
            color: 'rgba(231, 255, 214, 1)',
            imgsrc: '/images/teamMobile/team/ibraheem1.0.png',
            name: 'Ibrahim Zoqi',
            title: '',
            desigination: 'User Interface / User Experience / Graphic Design',
            role: '',
            href: 'https://www.linkedin.com/in/ibrahim-zoqi-a97b20233/',
        },
    ];
    const development = [
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: 'images/teamMobile/team/umair.png',
            name: 'Umair Khalil',
            title: '',
            desigination: 'Technical Lead',
            role: '',
            href: 'https://www.linkedin.com/in/umair-khalil-4a4b621a6/',
            linked: '/images/team/linkden.svg',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: 'images/teamMobile/team/zain.png',
            name: 'Muhammad Zain',
            title: '',
            desigination: 'Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/muhammad-zain-47412a1b3',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/sami.png',
            name: 'Sami Mazhar',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/sami-mazhar-60905b185',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/umar.png',
            name: 'Muhammad Umar',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/muhammad-umer-8b162720a/',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/hafsa.png',
            name: 'Hafsa Khalil',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/hafsa-khalil',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/rizwana.png',
            name: 'Rizwana Younas',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/rizwana-younas-50514956',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/ashar.png',
            name: 'Ashar Shahid',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/ashar-khan-71703023b/',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/owais.png',
            name: 'M. Awais',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/muhammad-awais-a9245016a',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/usjad.png',
            name: 'Muhammad Usjad',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/muhammadusjadchaudhry',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/rehman.png',
            name: 'Rehman Afzal',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/rehman-afzal-1285b320b',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: 'images/teamMobile/team/mudassir2.png',
            name: 'Mudassir Mirza',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/mudassirmirza/',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: 'images/teamMobile/team/shahzaib.png',
            name: 'Shahzaib Shah',
            title: '',
            desigination: 'Associate Software Engineer',
            role: '',
            href: 'https://www.linkedin.com/in/shahzaib-shah-b5b078171/',
        },
        {
            color: 'rgba(255, 208, 208, 1)',
            imgsrc: '/images/teamMobile/team/daniyal.png',
            name: 'Daniyal Ahmed',
            title: '',
            desigination:
                'Associate Software Engineer/ Scientific Research Associate',
            role: '',
            href: 'https://www.linkedin.com/in/dak-li',
        },
    ];
    const GROWTH = [
        {
            color: 'rgba(255, 231, 187, 1)',
            imgsrc: '/images/teamMobile/team/khudija.png',
            name: 'Khudija Tariqr',
            title: '',
            desigination: 'Content Producer',
            role: '',
            href: 'https://www.linkedin.com/in/khudija-tariq-60a94a172/',
        },
        {
            color: 'rgba(255, 231, 187, 1)',
            imgsrc: '/images/teamMobile/team/ibraheem2.0.png',
            name: 'Ibraheem Zahid',
            title: '',
            desigination: 'Organic Growth Manager',
            role: '',
            href: 'https://www.linkedin.com/in/ibraheem-zahid-a706b8180/',
        },
    ];
    const GOVERNMENTRELATIONS = [
        {
            color: 'rgba(211, 230, 255, 1)',
            imgsrc: '/images/teamMobile/team/umerdaud.png',
            name: 'Umar Daud',
            title: '',
            desigination: 'Federal Conctracts & Grant Proposal Writer',
            role: '',
            href: 'https://www.linkedin.com/in/umardaud/',
        },
    ];
</script>

<section>
    <div class="navbar">
        <MobileNavbar />
    </div>

    <div class="main-div">
        <div class="back-img">
            <img
                src="images/team/Backimg.png"
                alt=""
                width="100%"
                height="100%"
            />
            <div class="main-text"><p>the team</p></div>
            <div class="dropdown">></div>
        </div>

        <!------------------Team----------------------->

        <div class="team">
            {#each team as data}
                <div class="card">
                    <div
                        class="left-box"
                        style="background-color:{data.color};"
                    />
                    <div class="img-div">
                        <img
                            src={data.imgsrc}
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="contentWrraper">
                        <div class="content">
                            <div class="linkdenWrraper">
                                <div style="width:fit-content;">
                                    <h1>{data.name}</h1>
                                    <p>{data.title}</p>
                                    <p>{@html data.desigination}</p>
                                    <p>{data.role}</p>
                                </div>
                                <a href={data.href} target="__blank">
                                    <img
                                        src={data.linked}
                                        alt="linkden"
                                        width="100%"
                                        height="100%"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            {/each}
        </div>

        <!----------------------------------------->

        <div class="white-div">
            <div
                class="Teambox"
                style="background-color: rgba(169, 255, 112, 0.7);"
            >
                <div class="TeamboxContentHOlder">
                    <h1>DESIGN</h1>
                </div>
            </div>
        </div>
    </div>

    <!-- ----------------design--------------------- -->

    <div class="design">
        {#each design as data}
            <div class="card">
                <div class="left-box" style="background-color:{data.color};" />
                <div class="img-div">
                    <img src={data.imgsrc} alt="" width="100%" height="100%" />
                </div>
                <div class="contentWrraper">
                    <div class="content">
                        <div class="linkdenWrraper">
                            <div style="width:fit-content;">
                                <h1>{data.name}</h1>
                                <p>{data.title}</p>
                                <p>{@html data.desigination}</p>
                                <p>{data.role}</p>
                            </div>
                            <a href={data.href} target="__blank">
                                <img
                                    src="images/team/linkden.svg"
                                    alt="linkden"
                                    width="100%"
                                    height="100%"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <!-- ----------------------------------------- -->
    <div class="white-div">
        <div class="Teambox" style="background-color:#FF9B9B ;">
            <div class="TeamboxContentHOlder">
                <h1>Development</h1>
            </div>
        </div>
    </div>

    <!-- ----------------design--------------------- -->

    <div class="development">
        {#each development as data}
            <div class="card">
                <div class="left-box" style="background-color:{data.color};" />
                <div class="img-div">
                    <img src={data.imgsrc} alt="" width="100%" height="100%"   style="border-radius: 5vw 5vw 5vw 0vw;" />
                </div>
                <div class="contentWrraper">
                    <div class="content">
                        <div class="linkdenWrraper">
                            <div style="width:fit-content;">
                                <h1>{data.name}</h1>
                                <p>{data.title}</p>
                                <p>{data.desigination}</p>
                                <p>{data.role}</p>
                            </div>
                            <a href={data.href} target="__blank">
                                <img
                                    src="images/team/linkden.svg"
                                    alt="linkden"
                                    width="100%"
                                    height="100%"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <!-- ----------------------------------------- -->
    <div class="white-div">
        <div class="Teambox" style="background-color:#FDC55E ;">
            <div class="TeamboxContentHOlder">
                <h1>Growth & Marketing</h1>
            </div>
        </div>
    </div>

    <div class="GROWTH">
        {#each GROWTH as data}
            <div class="card">
                <div class="left-box" style="background-color:{data.color};" />
                <div class="img-div">
                    <img src={data.imgsrc} alt="" width="100%" height="100%" />
                </div>
                <div class="contentWrraper">
                    <div class="content">
                        <div class="linkdenWrraper">
                            <div style="width:fit-content;">
                                <h1>{data.name}</h1>
                                <p>{data.title}</p>
                                <p>{data.desigination}</p>
                                <p>{data.role}</p>
                            </div>
                            <a href={data.href} target="__blank">
                                <img
                                    src="images/team/linkden.svg"
                                    alt="linkden"
                                    width="100%"
                                    height="100%"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <!-- ----------------------------------------- -->
    <div class="white-div">
        <div class="Teambox" style="background-color:#71ACFF ;">
            <div class="TeamboxContentHOlder">
                <h1>GOvernment Relations</h1>
            </div>
        </div>
    </div>

    <div class="government">
        {#each GOVERNMENTRELATIONS as data}
            <div class="card">
                <div class="left-box" style="background-color:{data.color};" />
                <div class="img-div">
                    <img src={data.imgsrc} alt="" width="100%" height="100%" />
                </div>
                <div class="contentWrraper">
                    <div class="content">
                        <div class="linkdenWrraper">
                            <div style="width:fit-content;">
                                <h1>{data.name}</h1>
                                <p>{data.title}</p>
                                <p>{data.desigination}</p>
                                <p>{data.role}</p>
                            </div>
                            <a href={data.href} target="__blank">
                                <img
                                    src="images/team/linkden.svg"
                                    alt="linkden"
                                    width="100%"
                                    height="100%"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <!-- ----------------------------------------- -->
    <div>
        <MobileFooter />
    </div>
</section>

<style>
    .navbar {
        width: 100%;
        position: fixed;
        z-index: 1;
    }
    .main-div {
        width: 100%;
        height: 100%;
        font-family: "Orbitron";
    }
    .back-img {
        width: 100%;
        height: max(194.86vw,90.21vh);
        position: relative;
        padding-top: 21.495vw;
        background-color: black;
    }
    .main-text {
        position: absolute;
        right: 7.477vw;
        bottom: 74.533vw;
    }
    .main-text p {
        margin: 0vw;
        color: #ee9808;
        font-size: 7.009vw;
        font-weight: 700;
        text-transform: uppercase;
    }
    .dropdown {
        position: absolute;
        color: white;
        bottom: 6.423vw;
        left: 48vw;
        transform: rotate(90deg);
        font-size: 4.673vw;
        font-weight: 700;
        width: 4.558vw;
        height: 5.841vw;
    }
    .team {
        width: 100%;
        background-color: #f4eeec;
        height: 193.71vw;
        box-sizing: border-box;
        padding-top: 14.72vw;
    }
    .card {
        position: relative;
        margin-bottom: 14.019vw;
    }
    .card::before {
        content: "";
        position: absolute;
        width: 55.598vw;
        height: 38.084vw;
        background-color: white;
        right: 0vw;
        bottom: 0vw;
    }
    .left-box {
        position: absolute;
        width: 10.514vw;
        height: 13.551vw;
        left: 0vw;
        bottom: 24.533vw;
    }
    /* .card::after {
        content: "";
        position: absolute;
        width: 10.514vw;
        height: 13.551vw;
        background-color: white;
        left: 0vw;
        bottom: 24.533vw;
    } */
    .img-div {
        width: 40.888vw;
        height: 46.729vw;
        margin-left: 10.514vw;
        position: relative;
    }
    .contentWrraper {
        font-family: "Orbitron";
        width: 37.916vw;
        position: absolute;
        right: 5.374vw;
        bottom: 5.374vw;
    }
    .content h1 {
        font-size: 3.738vw;
        font-weight: 700;
        margin-bottom: 4.206vw;
        letter-spacing: 00.02em;
    }
    .content p {
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.516vw;
        margin: 0;
        letter-spacing: 00.02em;
    }
    .linkdenWrraper img {
        width: 4.206vw;
        height: 4.206vw;
    }
    a {
        text-decoration: none;
        color: inherit;
        float: right;
        margin-top: 4.439vw;
    }
    .Teambox {
        width: 100%;
        height: 100%;
        /* margin: 0vw; */
        background-color: rgba(231, 255, 214, 1);
    }
    .Teambox h1 {
        font-size: 9.346vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        /* width: max(56.574vh, 305.5px); */
        margin: 0;
        text-transform: uppercase;
    }
    .TeamboxContentHOlder {
        text-align: center;
        width: fit-content;
        margin: auto;
        display: flex;
        height: 100%;
        align-items: center;
    }
    .white-div {
        background-color: white;
        width: 100%;
        box-sizing: border-box;
        height: 42.757vw;
        padding: 1vw 1vw 1vw 1vw;
    }

    .design {
        width: 100%;
        height: 136.262vw;
        background-color: #f4eeec;
        box-sizing: border-box;
        padding-top: 14.72vw;
    }

    .development {
        width: 100%;
        height: 803.748vw;
        background-color: #f4eeec;
        box-sizing: border-box;
        padding-top: 14.72vw;
    }
    .GROWTH {
        width: 100%;
        height: 135.514vw;
        background-color: #f4eeec;
        box-sizing: border-box;
        padding-top: 14.72vw;
    }
    .government {
        width: 100%;
        height: 74.514vw;
        background-color: #f4eeec;
        box-sizing: border-box;
        padding-top: 14.72vw;
    }
</style>
